import type { FieldSpec } from '@wix/wix-data-schema-types'
import { Schema } from '@wix/wix-data-schema-types'

export { Schema }

export interface GetAllOptions {
  includeDeletedCollections?: boolean
  includeHiddenAppCollections?: boolean
}

export interface Transport {
  loadSchema: (collectionId: string) => Promise<Schema>
  listSchemas: (options?: GetAllOptions) => Promise<Schema[]>
  saveSchema: (collectionId: string, schema: Schema) => Promise<void>
  removeSchema: (collectionId: string) => Promise<void>
}

export interface CollectionsApi {
  execute: (operation: SchemaOperation) => Promise<void>
  get: (collectionId: string) => Promise<Schema>
  getSome: (collectionIds: string[]) => Promise<Schema[]>
  getAll: (options?: GetAllOptions) => Promise<Schema[]>
  getReferring: (collectionId: string) => Promise<Schema[]>
}

export enum PatchType {
  ADD = 'add',
  REMOVE = 'remove',
}

export interface Patch {
  op: PatchType
  path: string
  value?: any
}

export type Patches = Patch[] | Array<Patch[]>

export enum SchemaOperationType {
  CREATE = 'CREATE',
  UPDATE = 'UPDATE',
  REMOVE = 'REMOVE',
  RESTORE = 'RESTORE',
}

export type SchemaOperation = {
  type: SchemaOperationType
  collectionId: string
  patches?: Patches
}

export enum Role {
  ADMIN = 'admin',
  ANYONE = 'anyone',
  SITE_MEMBER = 'siteMember',
  SITE_MEMBER_AUTHOR = 'siteMemberAuthor',
}

export interface IndexedFields {
  [fieldName: string]: IndexedFieldSpec
}
export type IndexedFieldSpec = FieldSpec & {
  index: number
}

export type MaybeIndexedFieldSpec = FieldSpec & {
  index?: number
}

export interface MaybeIndexedFields {
  [fieldName: string]: MaybeIndexedFieldSpec
}

export interface FieldConfig {
  type?: string
  displayName?: string
  calculator?: {
    id: string
    config: { pattern: string }
  }
  pluginId?: string
  plugin?: string
  queryOperators?: string[]
  systemField?: boolean
  sortable?: boolean
  isDeleted?: boolean
  referencedCollection?: string
  referencingFieldKey?: string
  referencingDisplayName?: string
  pii?: boolean
  readOnly?: boolean
}

export interface IndexedSchema extends Schema {
  fields: IndexedFields
}
